import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { PlayerEvents } from './player.service';


@Injectable({
  providedIn: 'root'
})
export class VimeoService {

	private Player: any = false;
	private embedded: boolean = false;
	private renderer: Renderer2;
	private tryLoadScript: number = 0;

	constructor(
		@Inject(DOCUMENT) private _document:any,
		private playerEvents: PlayerEvents,
		private rendererFactory: RendererFactory2
	) {
		// Get an instance of Renderer2
    this.renderer = this.rendererFactory.createRenderer(null, null);

	}

	/* AGNOSTIC PLAYER EVENTS */

	private playerEvent = (event: string) => {
		this.playerEvents.playerEvent(event);
	}

	/* CONTROLL */

	public playVideo = (): void => {
		console.log('**** VimeoService playVideo this.Player ', this.Player);
		this.Player.play();
	}

	public pauseVideo = (): void => {
		console.log('**** VimeoService pauseVideo this.Player ', this.Player);
		this.Player.pause();
	}

	/* LOAD SCRIPT */

	public loadScript = (medium: any) => {

		if (!this.embedded) {
			
			const s = this.renderer.createElement('script');
			s.type = 'text/javascript';
			s.src = 'https://player.vimeo.com/api/player.js';
			s.text = ``;

			this.renderer.appendChild(this._document.body, s);
			s.onload = this.onScriptLoad(medium);

			this.embedded = true;
		}
		else {
			this.loadVideo(medium);
		}
		
	}

	private onScriptLoad = (medium: any) => {
    console.log('**** VimeoService onScriptLoad medium ', medium);
    

    setTimeout(
    	() => {
    		
    		console.log('**** VimeoService onScriptLoad medium ', medium);

    		this.loadVideo(medium);
    	},
    	100
    );

    //this.loadVideo(medium);
  }

	/*  PLAYER Vimeo API */

	private loadVideo(medium:any) {
	  console.log('VimeoService loadVideo medium',  medium);
	  console.log('VimeoService loadVideo (window as any)[Vimeo]',  (window as any)['Vimeo']);

	  if ((window as any)['Vimeo']) {

	  	const uid = medium.playerName + medium.id + medium.provider;
			const settings = {
		  		
	  		id: medium.id,
	  		width: medium.dimensions.width,
	  		height: medium.dimensions.height,
	  		title: false,
	  		color: '6b4050'
	  	};

	  	this.Player = new (window as any)['Vimeo'].Player(uid, settings);

	  	const _that:any = this;

	  	this.Player.on('loaded', function(event:any, that:any = _that) {

	  		console.log('VimeoService loadVideo LOADED event ',  event);
	  		console.log('VimeoService loadVideo LOADED that ',  that);
	  		//console.log('VimeoService loadVideo LOADED that.playing ',  that.playing);

	  		that.Player.play();
	  		
	  		that.playerEvent('loaded');
	  	});

	  	this.Player.on('play', function(event:any, that:any = _that) {

	  		console.log('VimeoService loadVideo PLAY event ',  event);
	  	
	  		that.playing = true;
	  		that.playerEvent('play');

	  	});

	  	this.Player.on('pause', function(event:any, that:any = _that) {

	  		console.log('VimeoService loadVideo STOPPED event ',  event);
	  		
	  		that.playing = false;
	  		that.playerEvent('pause');

	  	});

	  	console.log('VimeoService loadVideo this.player ',  this.Player);	
	  }
	  else if (this.tryLoadScript <= 10) {
	  	this.tryLoadScript++;
	  	this.onScriptLoad(medium);
	  }
	}

	/* PRIVATE */

	private onPlayerReady = (player:any) => {
	  console.log('onPlayerReady VimeoService event ',  event);
	  //console.log('onPlayerReady VimeoService this.Player ',  this.Player);
	  //console.log('onPlayerReady VimeoService this ',  this);
	  //console.log('onPlayerReady VimeoService (window as any)[Vimeo].Player ',  (window as any)['Vimeo'].Player);
	  //console.log('onPlayerReady VimeoService (window as any)[Vimeo].Player ',  (window as any)['Vimeo'].Player);

	  const that = this;

	  player.play().then(function() {
	  console.log('onPlayerReady The video is playing VimeoService',  event);
  		// The video is playing
		}).catch(function(error:any) {
			
			that.playerEvent('error');

  		switch (error.name) {
		    case 'PasswordError':
			  	console.log('onPlayerReady The video is password-protected VimeoService',  error);
		        // The video is password-protected
		        break;

		    case 'PrivacyError':
			  	console.log('onPlayerReady The video is private VimeoService',  error);
		        // The video is private
		        break;

		    default:
			  	console.log('onPlayerReady Some other error occurred VimeoService',  error);
		        // Some other error occurred
		        break;
  		}
		})
	}
}